import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    trainRegions: [],
  }),

  mutations: {
    setTrainRegions(state, trainRegions) {
      Vue.set(state, "trainRegions", trainRegions);
    },
  },

  actions: {
    //TODO: load, update, create
    createTrainRegion: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/train-regions/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadTrainRegions: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-regions/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadTrainRegion: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-regions/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadPublishedTrainRegions: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-regions/entity/published").then((response) => {
        // context.commit("setTrainRegions",response.data);
        return response;
      });
    },

    loadTrainRegionHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/train-regions/entity/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedTrainRegionHistory: (context, trainRegion) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-regions/history/" + trainRegion.id, {}).then((response) => {
        return response.data;
      });
    },

    searchTrainRegionByStationId: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/train-regions/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deleteTrainRegion: (context, trainRegion) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train-regions/entity/" + trainRegion.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          trainRegion.intents = intents;
          trainRegion.intentId = response.data.id;
          return trainRegion;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftTrainRegion: (context, trainRegion) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train-regions/draft/" + trainRegion.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishTrainRegion: (context, trainRegion) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-regions/publish/" + trainRegion.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectTrainRegion: (context, trainRegion) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-regions/reject/" + trainRegion.intentId).then((response) => {
        helper.recallOrRejectEntity(trainRegion, "trainRegion");
        return response.data;
      });
    },

    sendToApprovalTrainRegions: (context, trainRegion) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-regions/sendToApproval/" + trainRegion.intentId).then((response) => {
        if (trainRegion.intents[0].type === "CREATE_TITLE") {
          trainRegion.intents[0].status = "WAITING_APPROVAL";
        } else if (trainRegion.intents[0].type === "UPDATE_TITLE") {
          trainRegion.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallTrainRegion: (context, trainRegion) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-regions/recall/" + trainRegion.intentId).then((response) => {
        helper.recallOrRejectEntity(trainRegion, "trainRegion");
        return response.data;
      });
    },

    cancelTrainRegion: (context, trainRegion) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-regions/cancel/" + trainRegion.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getTrainRegions: (state) => {
      return state.trainRegions;
    },
    getPublishedTrainRegions: (state) => {
      return state.trainRegions.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
